import axios from 'axios';
import {
  createContext,
  ReactChild,
  useCallback,
  useReducer,
  useState,
} from 'react';
import { toast } from 'react-toastify';
import { RequestAccountType } from '../../types/Types';
import { getError } from '../../utils/getError.utils';
import ActionTypes from '../Action.types';
import { RequestAccountsReducer } from './RequestPages.reducer';

export const RequestPagesContext = createContext({
  requestPageState: {
    requests: [] as RequestAccountType[],
    isLoading: false,
  },
  createRequest: (type: string, quantity: number, accessToken: string) => {},
  findAllRequestPage: (status: string) => {},
  findWithUserId: (status: string, accessToken: string) => {},
  deleteRequest: (id: string, role: string) => {},
  updateRequest: (request: RequestAccountType) => {},
  requestPageAlert: [] as RequestAccountType[],
});

interface RequestProps {
  children: ReactChild;
}

const INITIAL_STATE = {
  requests: [] as RequestAccountType[],
  isLoading: false,
};

const RequestPagesProvider = ({ children }: RequestProps) => {
  const [state, dispatch] = useReducer(RequestAccountsReducer, INITIAL_STATE);

  const [requestPageAlert, setRequestPageAlert] = useState<RequestAccountType[]>([]);

  const findAllRequestPage = useCallback(async (status: string) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    const alert = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/requset-pages?status=1`
    );

    setRequestPageAlert(alert.data);

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/requset-pages?status=${status}`
    );

    dispatch({ type: ActionTypes.find, payload: res.data });
  }, []);

  const findWithUserId = useCallback(
    async (status: string, accessToken: string) => {
      dispatch({ type: ActionTypes.start, payload: '' });
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/requset-pages/findWithUserId?status=${status}`,
        {
          headers: { authorization: 'Bearer ' + accessToken },
        }
      );
      dispatch({ type: ActionTypes.find, payload: res.data });
    },
    []
  );

  const createRequest = async (
    type: string,
    quantity: number,
    accessToken: string
  ) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      if (isNaN(quantity)) {
        toast.error('Quantity must me number.');
        dispatch({ type: ActionTypes.clear, payload: '' });
        return;
      }

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/requset-pages/check-quantity?type=${type}`
      );

      console.log(data);

      // if (res.data < quantity) {
      //   toast.warn(`Sorry, Accounst is out of stock.`);
      //   dispatch({ type: ActionTypes.clear, payload: '' });
      //   return;
      // }

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/requset-pages/create-request`,
        { type, quantity },
        {
          headers: { authorization: 'Bearer ' + accessToken },
        }
      );

      dispatch({ type: ActionTypes.create, payload: res.data });
      toast.success('Create request is successfully.');
    } catch (error: any) {
      dispatch({ type: ActionTypes.error, payload: '' });
      toast.error(`${getError(error)}`);
    }
  };

  const updateRequest = async (request: RequestAccountType) => {
    try {
      const update = state.requests
        .map((req) => (req._id === request._id ? { ...request } : req))
        .filter((req) => req.status === '1');

      setRequestPageAlert(update);

      dispatch({ type: ActionTypes.update, payload: request });
    } catch (error: any) {
      toast.error(`${getError(error)}`);
    }
  };

  const deleteRequest = async (id: string, role: string) => {
    dispatch({ type: ActionTypes.start, payload: '' });
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/requset-pages/findWithRequestId/${id}`
      );

      if (res.data.status === '2' && +role <= 3) {
        toast.error("Can't delete this request.");
        dispatch({ type: ActionTypes.clear, payload: '' });
        return;
      }

      const userData = JSON.parse(localStorage.getItem('userData') || '{}');
      const { data } = await axios.delete(
        `${process.env.REACT_APP_BACKEND_URL}/requset-pages/${id}`,
        {
          headers: { authorization: 'Bearer ' + userData.accessToken },
        }
      );

      const deleteData = requestPageAlert.filter((req) => req._id !== id);

      setRequestPageAlert(deleteData);

      dispatch({ type: ActionTypes.delete, payload: data });
      toast.success('Delete request is successfully.');
    } catch (error: any) {
      dispatch({ type: ActionTypes.error, payload: '' });
      toast.error(`${getError(error)}`);
    }
  };

  return (
    <RequestPagesContext.Provider
      value={{
        requestPageState: state,
        findAllRequestPage,
        findWithUserId,
        createRequest,
        deleteRequest,
        updateRequest,
        requestPageAlert,
      }}
    >
      {children}
    </RequestPagesContext.Provider>
  );
};

export default RequestPagesProvider;
